
// export const PAY_URL = "http://localhost:5000/api";

// export const PDF_URL = "http://localhost:5000";

export const PDF_URL = "https://application.vrishal.in";
export const PAY_URL = "https://application.vrishal.in/api";    